<template>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        width="24"
        height="24"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="margin-top: 2px"
    >
        <path d="M12 3v12" />
        <path d="M12 20.5v.01" />
    </svg>
</template>
